var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.746 17.535a.9.9 0 0 1 .69.05 6.643 6.643 0 0 0 3.014.714 6.75 6.75 0 0 0 6.037-3.736 6.641 6.641 0 0 0 .713-3.011l.001-.403c-.189-3.426-2.924-6.161-6.3-6.35h-.453a6.646 6.646 0 0 0-3.015.716 6.75 6.75 0 0 0-3.732 6.037 6.641 6.641 0 0 0 .714 3.011.9.9 0 0 1 .05.69l-1.14 3.423 3.421-1.141zm11.35-2.164a8.548 8.548 0 0 1-11.124 3.986l-4.786 1.595a.9.9 0 0 1-1.138-1.138l1.595-4.786A8.548 8.548 0 0 1 8.625 3.906 8.44 8.44 0 0 1 12.451 3l.5.001c4.341.24 7.808 3.707 8.049 8.098v.45a8.438 8.438 0 0 1-.905 3.822z",
    fill: "#8F9BB3",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoMessageIcon);
export default __webpack_public_path__ + "static/media/auto-message-icon.af276473.svg";
export { ForwardRef as ReactComponent };